
import React from 'react';
import AlarmsTable from './AlarmsTable';
import AlarmTelemetryChart from './AlarmTelemetryChart';
import { recentAlarms } from '@/data/energy-analytics-data';

interface AlarmsTabProps {
  onDeviceClick: (device: typeof recentAlarms[0]) => void;
}

const AlarmsTab = ({ onDeviceClick }: AlarmsTabProps) => {
  return (
    <div className="space-y-6">
      <AlarmsTable onDeviceClick={onDeviceClick} />
      <AlarmTelemetryChart />
    </div>
  );
};

export default AlarmsTab;
